import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft, Timer, KeyRound, PhoneMissed, Percent, Banknote, MessageCircle, BookOpen } from "lucide-react";

const RULE_ICONS = [
  <Timer className="w-5 h-5" />,
  <KeyRound className="w-5 h-5" />,
  <PhoneMissed className="w-5 h-5" />,
  <Percent className="w-5 h-5" />,
  <Banknote className="w-5 h-5" />,
  <MessageCircle className="w-5 h-5" />,
];

/** Aide-mémoire : les règles essentielles du livreur (récap des réponses du quiz). */
export default function DriverRules() {
  const { t } = useTranslation();
  const rules = RULE_ICONS.map((icon, i) => ({
    icon,
    title: t(`drules.r${i + 1}t`),
    text: t(`drules.r${i + 1}x`),
  }));
  return (
    <div className="max-w-2xl mx-auto px-4 py-10" data-testid="driver-rules-page">
      <Link to="/driver" data-testid="rules-back-link" className="inline-flex items-center gap-1.5 text-sm text-mute hover:text-brand-red mb-6">
        <ArrowLeft className="w-4 h-4" /> {t("drules.back")}
      </Link>
      <div className="text-center mb-8">
        <div className="w-14 h-14 rounded-full bg-[#FFF5F6] text-brand-red grid place-items-center mx-auto mb-3">
          <BookOpen className="w-7 h-7" />
        </div>
        <div className="text-xs uppercase tracking-[0.25em] text-brand-red mb-1">{t("drules.kicker")}</div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold">{t("drules.title")}</h1>
        <p className="text-sm text-mute mt-2">{t("drules.intro")}</p>
      </div>
      <div className="space-y-3">
        {rules.map((r, i) => (
          <div key={i} className="bg-white border border-sand rounded-2xl p-4 flex gap-4 items-start" data-testid={`rule-card-${i + 1}`}>
            <div className="w-10 h-10 rounded-full bg-[#FFF5F6] text-brand-red grid place-items-center shrink-0">{r.icon}</div>
            <div>
              <h2 className="font-display text-base font-semibold mb-1">{i + 1}. {r.title}</h2>
              <p className="text-sm text-mute leading-relaxed">{r.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
